import { render, staticRenderFns } from "./discosybares.vue?vue&type=template&id=ff78f8a8&scoped=true&"
import script from "./discosybares.vue?vue&type=script&lang=js&"
export * from "./discosybares.vue?vue&type=script&lang=js&"
import style0 from "./discosybares.vue?vue&type=style&index=0&id=ff78f8a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff78f8a8",
  null
  
)

export default component.exports